<template>
  <div
    class="card"
    v-show="currentCardId == 'ai_mypr'"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="AIがあなたに最適なテキストを生成しています"
  >
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>AI自己PRを入力</h2>
        <p>
          質問に答えるだけで、AIがあなたの自己PRを作成してくれます。AIから提案された文章をご活用ください。<br />
          生成せず、自分で考えた文章を入力することも可能です。
        </p>
      </div>

      <div class="card-content">
        <div class="r-ai-format">
          <div v-if="!aiResultView">
            <ul class="example-sentence-list">
              <li class="example-sentence-item">
                <p class="question-title">
                  質問1.得意な科目、研究テーマ、〇〇ゼミなど
                </p>
                <div class="el-textarea">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="数学・外国語など"
                    title="得意な科目、研究テーマ、〇〇ゼミなど"
                    autocomplete="off"
                    v-model="formatData.campus_history_content"
                  />
                </div>
              </li>
              <li class="example-sentence-item">
                <p class="question-title">質問2.質問1に関するエピソードなど</p>
                <div class="el-textarea">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="粘り強く諦めない"
                    title="質問1に関するエピソードなど"
                    autocomplete="off"
                    v-model="formatData.campus_history_summary"
                  />
                </div>
              </li>
              <li class="example-sentence-item">
                <p class="question-title">質問3.学生生活で力を注いだこと</p>
                <div class="el-textarea">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="アルバイトなど"
                    title="学生生活で力を注いだこと"
                    autocomplete="off"
                    v-model="formatData.gakuchika_content"
                  />
                </div>
              </li>
              <li class="example-sentence-item">
                <p class="question-title">質問4.質問3に関するエピソードなど</p>
                <div class="el-textarea">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder="遅刻なし"
                    title="質問3に関するエピソードなど"
                    autocomplete="off"
                    v-model="formatData.gakuchika_summary"
                  />
                </div>
              </li>
            </ul>
            <div
              class="text-center r-btn-wrap prime-cv-block"
              style="margin-top: 0; margin-bottom: 20px"
            >
              <el-button type="button" class="r-ai-btn" @click="getAIMyprNew"
                >この内容でAI自己PRを作成</el-button
              >
            </div>
          </div>

          <div v-else>
            <ul
              class="example-sentence-list example-sentence-block"
              style="margin-bottom: 20px"
            >
              <li class="example-sentence-item">
                <p class="question-title">AIに提案された自己PR</p>
                <div class="body" v-html="aiCampusHistoryResult"></div>
                <br />
                <div class="body" v-html="aiGakuchikaResult"></div>
                <div class="flex prime-cv-block prime-cv-block-flex">
                  <el-button @click="applyGeneratedPr">
                    <span>{{
                      globalVar.isYagiPrime
                        ? 'この自己PRを使う'
                        : '途中までの自己PRを使う'
                    }}</span>
                  </el-button>
                  <div
                    v-if="!globalVar.isYagiPrime"
                    class="text-center r-btn-wrap prime-cv-block"
                    style="margin-top: 0"
                  >
                    <el-button
                      type="button"
                      class="r-ai-btn"
                      style="line-height: 1.2; padding: 3px 34px"
                      @click="viewPaymentYagiprime"
                      ><span>ヤギプライムに加入して</span
                      ><br />文章全体を取得する</el-button
                    >
                  </div>
                </div>
              </li>
            </ul>
            <div
              class="text-center r-btn-wrap prime-cv-block"
              v-if="globalVar.isYagiPrime"
              style="margin-bottom: 20px"
            >
              <el-button
                type="button"
                class="r-ai-btn"
                @click="aiResultView = false"
                >再度質問に答えて取得する</el-button
              >
            </div>
          </div>
        </div>
        <el-input
          type="textarea"
          v-model="formatData.reasonNew"
          v-proofread
          :autosize="{ minRows: textareaMinRows, maxRows: 15 }"
          placeholder="AI自己PRを作成すると、文章が入力されます。また、自分で考えた文章を入力することも可能です。"
        />
        <div class="attention-limit character" v-if="previewErrors.reasonNew">
          <i class="el-icon-warning"></i>
          入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useNewRirekishoFormatData } from '@/composables/format-edit/useNewRirekishoFormatData'
import { useNewRirekishoAiMypr } from '@/composables/format-edit/useNewRirekishoAiMypr'

defineProps<{
  currentCardId?: string
  previewErrors: Record<string, string>
  textareaMinRows: number
}>()

const { globalVar } = useHostServices()
const formatData = useNewRirekishoFormatData()
const {
  fullscreenLoading,
  aiResultView,
  aiCampusHistoryResult,
  aiGakuchikaResult,
  getAIMyprNew,
  viewPaymentYagiprime,
  applyGeneratedPr
} = useNewRirekishoAiMypr(formatData)
</script>

<style lang="scss" scoped>
.example-sentence-block {
  margin-bottom: 0;
  border: 1px solid #90bd67;
  border-radius: 10px;
  padding: 20px 20px 10px;
}

.prime-cv-block {
  text-align: center;

  :deep(.el-button) {
    color: #fff;
    background-color: #e3165c;
    border-color: #e3165c;
    margin: 10px 0;
  }
}

.prime-cv-block-flex {
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  .el-button {
    margin: 0;
  }

  .r-ai-btn {
    span {
      font-size: 12px;
    }
  }
}
</style>
